import React, { useState } from "react";
import PhotoAlbum, { Photo } from "react-photo-album";
import "react-photo-album/rows.css";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

// Matches --non-mobile in app/assets/stylesheets/config.css
const MOBILE_MAX_PX = 981;

interface Props {
  linkTitle: string;
  images: Photo[];
}

export default function Gallery(props: Props) {
  const [index, setIndex] = useState(-1);

  const { images, linkTitle } = props;

  const handleOpen = () => {
    setIndex(0);
  };

  return (
    <section className="gallery">
      <button onClick={handleOpen} className="icon open-button">
        {linkTitle}
      </button>
      <PhotoAlbum
        layout="rows"
        photos={images}
        targetRowHeight={(width) => (width < MOBILE_MAX_PX ? 180 : 300)}
        rowConstraints={(width) => ({
          minPhotos: 2,
          singleRowMaxHeight: width < MOBILE_MAX_PX ? 280 : 400
        })}
        spacing={(width) => (width < MOBILE_MAX_PX ? 8 : 12)}
        breakpoints={[MOBILE_MAX_PX, 1200]}
        onClick={({ index: current }) => setIndex(current)}
      />
      <Lightbox
        plugins={[Captions]}
        index={index}
        slides={images}
        open={index >= 0}
        close={() => setIndex(-1)}
      />
    </section>
  );
}
